import { motion } from "motion/react";
import Header from "../../components/feature/Header";
import Breadcrumbs from "../../components/feature/Breadcrumbs";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import CrossLinksFooter from "../../components/feature/CrossLinksFooter";
import SEO from "../../components/feature/SEO";

const valores = [
  { icon: "🤝", title: "Trato directo", desc: "Hablas con quien repara. Sin call centers ni intermediarios." },
  { icon: "👷", title: "Técnicos propios", desc: "Nuestro equipo, con nosotros desde el inicio. Sin subcontratistas." },
  { icon: "⏱️", title: "Cumplimos plazos", desc: "Si decimos martes, es martes. Lo prometemos y lo cumplimos." },
  { icon: "🛡️", title: "Garantía real", desc: "Respaldada por seguro de Responsabilidad Civil. Escrito y firmado." },
  { icon: "💯", title: "Sin sorpresas", desc: "El presupuesto que firmas es el que pagas. Punto final." },
];

const diferencias = [
  "Empresa LOCAL en Málaga (barrio San Andrés). Conocemos cada calle.",
  "NO somos plataforma intermediaria. Somos el taller que instala.",
  "Trabajamos con marcas premium: Somfy, Markilux, Tempotest, Cherubini.",
  "Técnicos certificados con +10 años de experiencia en persianas y toldos.",
  "Seguro de Responsabilidad Civil para tu tranquilidad.",
];

const marcas = [
  { name: "Somfy", desc: "Motores y automatización" },
  { name: "Markilux", desc: "Toldos premium alemanes" },
  { name: "Tempotest", desc: "Telas técnicas para toldos" },
  { name: "Cherubini", desc: "Motores y accesorios" },
];

export default function SobreNosotros() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Quiénes Somos | Persianas Toldos Málaga"
        description="Empresa familiar de Málaga con +10 años · desde 2015 en persianas, toldos y mosquiteras."
        canonical="/sobre-nosotros/"
        ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg"
        ogType="website"
        breadcrumbs={[
          { name: "Inicio", path: "/" },
          { name: "Sobre nosotros" },
        ]}
      />
      <Header />
      <Breadcrumbs />
      <main>
        {/* HERO */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="font-heading font-extrabold text-3xl md:text-5xl text-text-primary mb-5 leading-tight"
            >
              Quiénes Somos
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              className="font-body text-lg text-text-secondary max-w-2xl mx-auto"
            >
              Empresa familiar de Málaga con +10 años · desde 2015 en persianas, toldos y mosquiteras.
            </motion.p>
          </div>
        </section>

        {/* NUESTRA HISTORIA */}
        <section className="py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <motion.div
                className="w-full lg:w-1/2"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h2 className="font-heading font-extrabold text-2xl md:text-[32px] text-text-primary mb-5">
                  Nuestra historia
                </h2>
                <div className="font-body text-base text-text-secondary leading-relaxed space-y-4">
                  <p>
                    Fundada en 2015, <strong className="text-text-primary">Persianas Toldos Málaga</strong> nace de la pasión por ofrecer un servicio profesional y cercano. Empezamos con una furgoneta, herramientas de calidad y la convicción de que el cliente merece hablar directamente con quien repara.
                  </p>
                  <p>
                    Hoy operamos desde nuestro taller en <strong className="text-text-primary">San Andrés (Málaga capital)</strong>, atendiendo a toda la provincia y la Costa del Sol. Hemos crecido, pero mantenemos la misma filosofía: trato directo, precio justo y trabajo bien hecho.
                  </p>
                  <p>
                    Cada persiana arreglada, cada toldo instalado y cada mosquitera colocada es una pequeña historia de confianza. Llevamos miles de ellas.
                  </p>
                </div>
              </motion.div>
              <motion.div
                className="w-full lg:w-1/2"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 }}
              >
                <div className="bg-surface-alt rounded-2xl p-8 border border-border">
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-6">
                    Datos en cifras
                  </h3>
                  <div className="grid grid-cols-2 gap-6">
                    <div>
                      <div className="font-heading font-extrabold text-3xl text-primary mb-1">+10</div>
                      <div className="font-body text-sm text-text-secondary">Años de experiencia</div>
                    </div>
                    <div>
                      <div className="font-heading font-extrabold text-3xl text-primary mb-1">+8.000</div>
                      <div className="font-body text-sm text-text-secondary">Reparaciones realizadas</div>
                    </div>
                    <div>
                      <div className="font-heading font-extrabold text-3xl text-primary mb-1">31</div>
                      <div className="font-body text-sm text-text-secondary">Pueblos atendidos</div>
                    </div>
                    <div>
                      <div className="font-heading font-extrabold text-3xl text-primary mb-1">6</div>
                      <div className="font-body text-sm text-text-secondary">Técnicos en plantilla</div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* NUESTROS VALORES */}
        <section className="bg-surface-alt py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-extrabold text-2xl md:text-[32px] text-text-primary text-center mb-12">
              Nuestros valores
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
              {valores.map((v, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="text-center p-6 bg-white rounded-2xl border border-border hover:border-primary/30 transition-colors"
                >
                  <div className="text-4xl mb-3">{v.icon}</div>
                  <h3 className="font-heading font-bold text-base text-text-primary mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* LO QUE NOS DIFERENCIA */}
        <section className="py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-extrabold text-2xl md:text-[32px] text-text-primary text-center mb-12">
              Lo que nos diferencia
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {diferencias.map((d, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex items-start gap-3 p-4 bg-white border border-border rounded-xl"
                >
                  <span className="text-primary font-bold text-lg shrink-0 mt-0.5">✓</span>
                  <span className="font-body text-base text-text-secondary">{d}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* MARCAS */}
        <section className="bg-surface-alt py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-extrabold text-2xl md:text-[32px] text-text-primary text-center mb-10">
              Marcas con las que trabajamos
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl mx-auto">
              {marcas.map((m, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.1 }}
                  className="text-center p-6 bg-white rounded-2xl border border-border"
                >
                  <div className="font-heading font-extrabold text-xl text-text-primary mb-1">{m.name}</div>
                  <div className="font-body text-sm text-text-secondary">{m.desc}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* NUESTRO TALLER */}
        <section className="py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <motion.div
                className="w-full lg:w-1/2"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h2 className="font-heading font-extrabold text-2xl md:text-[32px] text-text-primary mb-5">
                  Nuestro taller
                </h2>
                <div className="space-y-4 font-body text-base text-text-secondary leading-relaxed">
                  <p>
                    <strong className="text-text-primary">Dirección:</strong><br />
                    Calle Pacífico 54, San Andrés<br />
                    29003 Málaga
                  </p>
                  <p>
                    <strong className="text-text-primary">Horario de taller:</strong>
                  </p>
                  <ul className="space-y-1 ml-1">
                    <li>Lunes a Viernes: 9:00 - 14:00 / 16:00 - 19:00</li>
                    <li>Sábados: 9:00 - 14:00</li>
                    <li>Domingos: Cerrado</li>
                  </ul>
                  <p className="text-sm text-text-secondary mt-4">
                    También hacemos visitas a domicilio en toda la provincia. Llámanos y coordinamos.
                  </p>
                </div>
                <a
                  href="https://www.google.com/maps?q=Calle+Pacifico+54+San+Andres+Malaga"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-6 bg-primary hover:bg-primary-dark text-white font-body font-bold text-sm px-6 py-3 rounded-pill transition-colors"
                >
                  <i className="ri-map-pin-line text-base"></i> Ver en Google Maps
                </a>
              </motion.div>
              <motion.div
                className="w-full lg:w-1/2"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 }}
              >
                <div className="rounded-2xl overflow-hidden border border-border h-[300px] lg:h-[360px]">
                  <iframe
                    title="Taller Persianas Toldos Málaga"
                    src="https://www.google.com/maps?q=Calle+Pacifico+54+San+Andres+Malaga&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                    allowFullScreen
                  ></iframe>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA FINAL */}
        <section className="bg-surface-alt py-16 md:py-20">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-text-primary mb-4">
              ¿Hablamos?
            </h2>
            <p className="font-body text-base text-text-secondary max-w-xl mx-auto mb-8">
              Llámanos o pide presupuesto. Te respondemos en menos de 24h. Sin compromiso.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+34951120770"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-base px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
              >
                <span>📞</span> 951 12 07 70
              </a>
              <a
                href="/presupuesto"
                className="inline-flex items-center gap-2 bg-text-primary hover:bg-slate-800 text-white font-body font-bold text-base px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
              >
                <span>📋</span> Pedir presupuesto gratis
              </a>
            </div>
          </div>
        </section>
      </main>
      <CrossLinksFooter />
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}